$(document).ready(function(){
    $('.ny-stars').owlCarousel({
        autoplay: false,
        center: true,
        loop: true,
        nav: true,
        dots:false,
        responsive: {
            0: {
                items: 1,
                dots:true,
                nav: false
            },
            360: {
                items: 2,
                dots:true,
                nav: false
            },
            960: {
                items: 3,
                dots:false,
                nav: true
            }
        }
    });
});
